<template>
  <div class="web-download">
    <div class="download-word"><span>A</span><span>P</span><span>P</span>下载</div>
    <div class="download-icon">
      <img src="../assets/images/common/download.png" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'cms-download',
    data() {
      return {

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .web-download {
    width: 380px;
    height: 240px;
    background-color: #FFFFFF;
    padding: 31px 76px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .download-word {
    width: 20px;
    font-size: 20px;
    color: #0861D1;
    line-height: 1;
    text-align: center;
    font-family: Source Han Sans CN Bold;
  }

  .download-word span {
    display: block;
    transform: rotate(90deg);
  }

  .download-icon img {
    width: 178px;
    height: 178px;
  }

  @media screen and (max-width: 800px) {
    .web-download {
      width: 100%;
      height: 55vw;
      margin-top: 6vw;
      justify-content: space-around;
      padding: 4vw 10vw;
    }

    .download-word {
      width: 5vw;
      font-size: 4vw;
    }

    .download-icon img {
      width: 46vw;
      height: 46vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Download.vue